import React from "react";
import LearningItemDetailsRoute from "../../components/pages/Learning-item-details/LearningItemDetailsRoute";

function NextSession() {
  return (
    <LearningItemDetailsRoute
      expectedType="SESSION"
      slugParam="session_slug"
    />
  );
}

export default NextSession;
